import { ENTITY_GROUP_REFERENCES } from '~/features/base/constants/entities';
import { entityStoreSelector } from '~/features/higherorder/selectors/dataSelectors';

const groupReferencesEntitiesSelector = state => entityStoreSelector(state)[ENTITY_GROUP_REFERENCES];

export const groupReferencesSelector = (state, ownProps) =>
    groupReferencesEntitiesSelector(state)[ownProps.groupName];
